import {entity} from "../rpc/api";
import ClientBrowsingHistoryList = entity.ClientBrowsingHistoryList;
// import moment from "moment"
import {FrontDate} from "../../../domain/model/frontDate";

class ClientBrowsingHistoryConvertResponse {

    public static from(from: entity.ClientBrowsingHistory): ClientBrowsingHistoryConvertResponse {

        // Backend => FrontEnd における型変換
        const createdAtDate: FrontDate = FrontDate.from(from.createdAt);

        return new ClientBrowsingHistoryConvertResponse(
            from.clientID,
            from.customerID,
            createdAtDate,
        )
    }

    constructor(public readonly clientID: string,
                public readonly customerID: string,
                public readonly createdAt: FrontDate,) {

    }

}

class ClientBrowsingHistoryConvertResponseList {

    public static from(from: ClientBrowsingHistoryList): ClientBrowsingHistoryConvertResponseList {
        const items: ClientBrowsingHistoryConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(ClientBrowsingHistoryConvertResponse.from(item as entity.ClientBrowsingHistory))
        });

        return new ClientBrowsingHistoryConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: ClientBrowsingHistoryConvertResponse[],
    ) {
    };

}

export {
    ClientBrowsingHistoryConvertResponse,
    ClientBrowsingHistoryConvertResponseList,
}


// WEBPACK FOOTER //
// ./src/infra/api/service/client_browsing_history_api_convert.ts